import React from "react";

const SegmentInput = ({ value, onChange, onSave, disabled, loading }) => (
  <div className="input-group" style={{ position: "sticky", top: 0, zIndex: 1 }}>
    <input
      type="text"
      className="form-control"
      placeholder="Enter segment name"
      value={value}
      onChange={e => onChange(e.target.value)}
      disabled={disabled || loading}
    />
    <div className="input-group-append">
      <button className="btn btn-success" onClick={onSave} disabled={disabled || loading}>
        {loading ? (
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        ) : (
          "Save"
        )}
      </button>
    </div>
  </div>
);

export default SegmentInput;